var map = {
	"./Icon.svg": 8180,
	"./SyngentaLogo.svg": 5879,
	"./addNew.svg": 1562,
	"./assessment.svg": 25,
	"./assessments.svg": 2760,
	"./check-circle-outline.svg": 4583,
	"./copyIcon.svg": 3259,
	"./deleteIcon.svg": 3401,
	"./deleteIconAssesment.svg": 4156,
	"./edit.svg": 6343,
	"./editSection.svg": 7540,
	"./edit_note.svg": 990,
	"./error.svg": 9303,
	"./expandedIcon.svg": 1183,
	"./fertilizer.svg": 1681,
	"./form-practices.svg": 3836,
	"./illustration_password_ok.svg": 1652,
	"./illustration_womanandplant.svg": 1384,
	"./information.svg": 547,
	"./landscape.svg": 970,
	"./logo.svg": 1533,
	"./mycropwise.svg": 7847,
	"./notification.svg": 5342,
	"./partners.svg": 8134,
	"./reports.svg": 2476,
	"./soil.svg": 5714,
	"./user.svg": 4514,
	"./warning.svg": 4137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;